import * as types from '../mutation_types';

export default {
  [types.SET_PARKING_SPACE](state, value) {
    state.parking_space = value;
  }
}
